'use client';

import { FAQ } from '@/components/FAQ';
import Link from 'next/link';

export interface ToolsFAQsProps {
	testId?: string;
}

const ToolsFAQs = (props: ToolsFAQsProps) => {
	const { testId = 'ToolsFAQs' } = props;

	return (
		<FAQ testId={testId}>
			<FAQ.Title>FAQ</FAQ.Title>
			<FAQ.Block>
				<FAQ.Item>
					<FAQ.Question panelId="1">
						What is the most useful HVAC calculator for homeowners?
					</FAQ.Question>
					<FAQ.Answer panelId="1">
						<p>
							All of our HVAC calculators are useful but serve different
							purposes. A good place to start is using our{' '}
							<Link
								className="text-sky-700 hover:text-sky-800 hover:underline"
								href={`/tools/repair-replace-calculator/`}
							>
								Repair or Replace Calculator
							</Link>
							. It recommends using a $3,000 threshold in conjunction with the
							system&apos;s age and warranty status to determine whether to
							repair or replace your HVAC system. From there, our{' '}
							<Link
								className="text-sky-700 hover:text-sky-800 hover:underline"
								href={`/tools/hvac-load-calculator/`}
							>
								HVAC Sizing Calculator
							</Link>{' '}
							helps you find the ideal system size for your home to ensure
							maximum efficiency and comfort. Our SEER Savings Calculator is
							coming soon. It will show you the potential savings from upgrading
							to a higher-SEER system and help you determine if the upgrade is
							worth it.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
				<FAQ.Item>
					<FAQ.Question panelId="2">
						Are your HVAC calculators free?
					</FAQ.Question>
					<FAQ.Answer panelId="2">
						<p>
							Yes, HVAC.com offers free HVAC calculators for all of your home
							comfort needs. Our tools are designed to provide you with helpful
							information at no cost.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
				<FAQ.Item>
					<FAQ.Question panelId="3">
						How accurate are your HVAC calculators?
					</FAQ.Question>
					<FAQ.Answer panelId="3">
						<p>
							Our HVAC calculators are built and tested by industry experts to
							ensure accuracy. They provide reliable estimates based on standard
							industry guidelines. To answer your specific questions, we
							recommend speaking with our HVAC technical advisors for a custom
							solution for your home.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
				<FAQ.Item>
					<FAQ.Question panelId="4">
						Can you help me replace my HVAC system?
					</FAQ.Question>
					<FAQ.Answer panelId="4">
						<p>
							Absolutely! We’re a tech company bringing a breath of fresh air to
							the HVAC world.{' '}
							<Link
								className="text-sky-700 hover:text-sky-800 hover:underline"
								href={`/replace/virtual/`}
							>
								Replace your HVAC
							</Link>{' '}
							with us and enjoy a customized solution with upfront pricing. Get
							an honest quote quickly by submitting a little information in just
							few easy steps. Our team will craft a custom solution for your
							home, ensuring you get the trusted help you deserve with fair,
							honest pricing.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
			</FAQ.Block>
		</FAQ>
	);
};

export default ToolsFAQs;
